import React, { useEffect, useState, useRef } from 'react';

//i18n
import '../i18/config';
import {useTranslation} from "react-i18next";
import Button from "react-bootstrap/Button";

interface AgainTimerProps {
    label: string,
    initialDuration: 0 | number,
    onFinish: () => void,
    btnClass?: string,
}

const AgainTimer = ({label, initialDuration = 0, onFinish, btnClass = 'btn-soft-dark'}:AgainTimerProps) => {
    const { t } = useTranslation(['auth']);
    const [timeLeft, setTimeLeft] = useState(initialDuration);
    const [isCounting, setIsCounting] = useState(false);

    const timerRef = useRef(null);

    useEffect(() => {
        if (isCounting && timeLeft > 0) {
            timerRef.current = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
        } else if (timeLeft === 0 && isCounting) {
            setIsCounting(false);
            clearInterval(timerRef.current);
        } else if (!isCounting && timeLeft>0) {
            startTimer();
        }

        return () => {
            clearInterval(timerRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCounting, timeLeft]);

    const startTimer = () => {
        setTimeLeft(initialDuration);
        setIsCounting(true);
    }

    const handleSendAgain = () => {
        if (!isCounting) {
            onFinish();
            startTimer();
        }
    };

    return (
        <>
            <Button
                type="button"
                disabled={isCounting}
                color="success"
                onClick={handleSendAgain}
                className={btnClass}>
                <>
                    {t(label)}
                    {isCounting && <> ({timeLeft})</>}
                </>
                </Button>
        </>
    );
};

export default AgainTimer;